import { getDetailedBanner } from '../../common/utilities/CustomBannerUtil';
import { setEnrollments, setWebAlerts, setCurrentUserState, fetchSubproducersInfoSuccess, fetchSubproducersInfoFailure, resetSubproducersInfo, resetProducts, resetAgentProfileInfo, resetContactProfileInfo } from '../../actions/actions';
import { fetchSubproducers, updateEnrollmentProperty } from '../../common/services/Services';
import constants from '../../constants'

const getDefaultPrismId = (enrollments) => {
    const isDefaultObjects = enrollments.filter(obj => obj.is_default === true);
    isDefaultObjects.forEach(obj => {
        const index = enrollments.indexOf(obj);
        if (index !== -1) {
            enrollments.splice(index, 1);
        }
    });
    const reorderedEnrollments = isDefaultObjects.concat(enrollments);
    return reorderedEnrollments;
}

const getCurrentPrismId = (enrollments) => {
    const isCurrentObject = enrollments.find(obj => obj.isCurrent === true || obj.isCurrent === 'true');
    const resultObject = isCurrentObject || enrollments[0];
    return resultObject ? resultObject.prismId : null;
}

const getCurrentPrismEnrollment = (enrollments) => {
    const isCurrentObject = enrollments.find(obj => obj.isCurrent === true || obj.isCurrent === 'true');
    const resultObject = isCurrentObject || enrollments[0];
    return resultObject ? resultObject : null;
}

const getEnrollmentByPrismId = (enrollments, userName) => {
    const enrollment = enrollments.find(obj => obj.prismId === userName);
    return enrollment ? enrollment : null;
}


const getPreferenceValue = (preferences, property, returnProperty, comparator) => {
    let value = null;
    preferences.forEach((preference) => {
        if (preference[property] === comparator) {
          value = preference[returnProperty];
          return;
        }
    });
    return value;
}
  
const stripUserDescription = (username) => {
    if(username !== undefined && username.includes(':')) {
    //if username may be in the format "Description: username" or "Username" (when description is empty)
    //we need to extract just the username when prepended by description
    var token = username.split(':');
     username = token[1].trimLeft();
    }
    return username;
}

const reorderNotifications = (messages) => {
    if (!messages || messages.length === 0) {
      return [];
    }

    const criticalNotifications = [];
    const nonCriticalNotifications = [];
    messages.forEach(message => {
      if (message.tags && message.tags.includes('AGSS_ALERT_CRITICAL')) {
        criticalNotifications.push(message);
      } else {
        nonCriticalNotifications.push(message);
      }
    });
  
    criticalNotifications.sort((a, b) => new Date(b.date) - new Date(a.date));
    nonCriticalNotifications.sort((a, b) => new Date(b.date) - new Date(a.date));
    const combinedNotifications = [...criticalNotifications, ...nonCriticalNotifications];  
    const menuItems = combinedNotifications.map(message => ({ ...message, type: constants.notification }));
  
    return menuItems;
  }

function getDomainFromEmail(email) {
    const [, domain] = email.split('@');
    return domain;
}

const initiateRestrictedErrorBanner = (setGlobalBannerProps, setShowGlobalBanner, setShowMinifiedHeader, errorMsg) => {
  const banner = getDetailedBanner(
    constants.errorText, 
    constants.serviceUnavailableMsg,
    constants.pleaseTryAgainMsg,
    `Error message: ${errorMsg}`,
    '', 
    undefined,
    true
  );
  setGlobalBannerProps(banner);
  setShowGlobalBanner(true);
  setShowMinifiedHeader(true);
};

const initiateErrorBanner = (setGlobalBannerProps, setShowGlobalBanner, errorMsg, dismissCriticalBanner) => {
  const banner = getDetailedBanner(
    constants.errorText, 
    constants.serviceUnavailable,
    constants.pleaseTryAgainMsg, 
    'Error message: ' + errorMsg + '', 
    undefined, 
    () => { dismissCriticalBanner() },
    true
  )
  setGlobalBannerProps(banner);
  setShowGlobalBanner(true);
};

function getNullSafeProperty(obj, path) {
  return path.reduce((acc, prop) => (acc && acc[prop] !== undefined) ? acc[prop] : undefined, obj);
}

const getAgencyName = (selectedUserCode, agents) => {
  if(agents.length === 0) {
    return '';
  }
  const agent = agents.find(obj => obj.mAgentCd && obj.mAgentCd === selectedUserCode);
  const agentName = agent && agent.mDisplayName ? agent.mDisplayName : '';
  return agentName;
};

const isNewUserName = async (contactInfo, userName) => {
  if (typeof contactInfo === 'string' && contactInfo.includes('Contact not found.')) {
    return true;
  }
  if ((userName && userName.length > 0) && (!contactInfo.enrollments.some(enrollment => enrollment.prismId === userName))) {
    return true;
  }

  return false;
};

const getSubproducers = async (agent, username, setIsLoading, openGlobalBanner, hideErrorBanner, refreshToken, dispatch) => {
    try {
      setIsLoading(true);
      const { token } = await refreshToken();
      const trimmedAgent = agent.split(',')[0];
      const subproducerInfo = await fetchSubproducers(trimmedAgent, username, token);
      hideErrorBanner();
      dispatch(fetchSubproducersInfoSuccess(subproducerInfo.length > 0 ? subproducerInfo :  ['']));
    } catch (err) {
      openGlobalBanner(err);
      dispatch(fetchSubproducersInfoFailure(err));
    } finally {
      setIsLoading(false);
    }
}

 const findDisplayName = (policyData, nameList) => {
    return policyData.map(policy => {
        const { productCode, sectionCode } = policy.lob;
        const matchedItem = nameList.find(item => item.productCode === productCode && item.sectionCode === sectionCode);
        if (matchedItem) {
            policy.displayName = matchedItem.displayName;
        } else {
            policy.displayName = '';
        }
        return policy;
    });
  }


const findProductByDisplayName = (displayName, productsData) => {
    const matchedItem = productsData.find(item => item.displayName === displayName);
    if (matchedItem) {
        return {
            productCode: matchedItem.productCode,
            sectionCode: matchedItem.sectionCode
        };
    } 

    return {productCode: '', sectionCode: ''};
};

// This will remove properties from the passed in object. Originally implemented for enhanced-search as blank values can cause backend errors
const cleanObject = (obj) => {
    Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object') {
            cleanObject(obj[key]);
        } else if (obj[key] === '' || obj[key] === undefined || obj[key] === null) {
            delete obj[key];
        }
    });
    return obj;
};

const generateNonce = () => {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
}

const updateAndGetSelectedEnrollment = (enrollments, userName, token) => {
  let updatedEnrollments = null;
  let newlySelectedUser = null;
  updatedEnrollments = enrollments.map(enrollment => {
    if (enrollment.prismId === userName) {
      newlySelectedUser = { ...enrollment, isCurrent: 'true' };
      return newlySelectedUser;
    }
    return { ...enrollment, isCurrent: 'false' };
  });

  newlySelectedUser = newlySelectedUser === null ? enrollments[0] : newlySelectedUser ;

  // Update enrollment in CRM
  enrollments.forEach(enrollment => {
    const isCurrentEnrollment = enrollment.prismId === newlySelectedUser.prismId;
    const shouldUpdate = isCurrentEnrollment || (enrollment.isCurrent === 'true' || enrollment.isCurrent === true);
    if (shouldUpdate) {
        const newStatus = isCurrentEnrollment ? 'true' : 'false';
        updateEnrollmentProperty(enrollment.guid, 'new_iscurrent', newStatus, token);
    }
  });

  return {updatedEnrollments, newlySelectedUser};
}

  const getLinks = (links, linkCategory) =>{
    return links.filter(function(link) {
      return link.category === linkCategory;
    });
  }

  const resetReducers = async (dispatch) => {
    dispatch(resetAgentProfileInfo());
    dispatch(resetContactProfileInfo());
    dispatch(resetSubproducersInfo());
    dispatch(resetProducts());
    dispatch(setEnrollments([]));
    dispatch(setWebAlerts([]));
    dispatch(setCurrentUserState(null));
  }

  const replacePath = (location, path) => {
    location.pathname = path;
  }

  //to handle list length of 1 and > 1  and for internal user with no mAgentCd and for external Users with mAgentCd.
  function formatAgentsList(agentsList){
    if (!Array.isArray(agentsList) || agentsList.length === 0) {
      return "";
    }
    const formattedList = agentsList.map((agent) => {
      const agentCd = agent.mAgentCd;
      const mGroupName = agent.managingGroupName;
      if (agentCd && mGroupName) {
        return agentCd + "-" + mGroupName;
      }
      if (agentCd) {
        return agentCd;
      }
      if (mGroupName) {
        return mGroupName;
      }
      return "";
    });

    return formattedList.filter(item => item !== "").join(", ");
  };

export { getDefaultPrismId, getCurrentPrismEnrollment, getCurrentPrismId, getEnrollmentByPrismId, getPreferenceValue, stripUserDescription, reorderNotifications, getDomainFromEmail, initiateRestrictedErrorBanner, initiateErrorBanner, getNullSafeProperty, getAgencyName, isNewUserName, getSubproducers, findDisplayName, findProductByDisplayName, cleanObject, generateNonce, updateAndGetSelectedEnrollment, getLinks, resetReducers, replacePath, formatAgentsList};
